/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Attemptrecords1Inputs */

const zh_learn_attemptrecords1 = /** @type {(inputs: Learn_Attemptrecords1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作答记录`)
};

const en_learn_attemptrecords1 = /** @type {(inputs: Learn_Attemptrecords1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt Records`)
};

const es_learn_attemptrecords1 = /** @type {(inputs: Learn_Attemptrecords1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de intentos`)
};

/**
* | output |
* | --- |
* | "Attempt Records" |
*
* @param {Learn_Attemptrecords1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_attemptrecords1 = /** @type {((inputs?: Learn_Attemptrecords1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Attemptrecords1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_attemptrecords1(inputs)
	if (locale === "en") return en_learn_attemptrecords1(inputs)
	return es_learn_attemptrecords1(inputs)
});
export { learn_attemptrecords1 as "learn_attemptRecords" }